export enum SolarIntent {
  RENT = 'RENT',
  BUY = 'BUY',
  BOTH = 'BOTH',
  NOT_SURE = 'NOT_SURE',
}

export const solarIntentGermanString: { [k in keyof typeof SolarIntent]: string } = {
  RENT: 'Mieten',
  BUY: 'Kaufen',
  BOTH: 'Beides interessant',
  NOT_SURE: 'Weiß ich nicht',
}
